import * as React from 'react';
import { toast } from 'react-toastify';

interface DriverJobsSiteDepartureSkipProps {
    notes: string;
    saveDisabled: boolean;
    back(): void;
    update(notes: string): void;
    save(): void;
}

interface DriverJobsSiteDepartureSkip {
    loading: boolean;
    errors: any;
}

export default class DriverJobsSiteDepartureSkipData extends React.Component<DriverJobsSiteDepartureSkipProps, DriverJobsSiteDepartureSkip> {
    constructor(props: DriverJobsSiteDepartureSkipProps) {
        super(props);

        this.state = {
            loading: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        this.setState({ errors: errors })
        this.props.update(e.target.value);
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (!this.props.notes) {
            formIsValid = false;
            errors["notes"] = "Reason is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        } else {
            toast.error("Fix validation errors on screen before going Next");
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Can't Do Job</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>

                    <span className="makeitred makeitbold">Call your supervisor to let them know why you can't do this job so they can reschedule.</span>

                    <label className="input-group marginTop10" htmlFor="notes">
                        <span className="label-mobile">Enter reason why you can't do the job</span>
                        <textarea className="input job__noteSize label-mobile" id="notes" name="notes" value={this.props.notes} onChange={(e) => this.handleChange(e)}></textarea>
                    </label>
                    <span className={this.state.errors["notes"] ? "label errors" : "hidden"}>{this.state.errors["notes"]}</span>

                    <div className="defaultbutton__container--right marginTop10">
                        <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (this.props.saveDisabled ? " mobile-image-button--disabled" : "")} onClick={(e) => this.save(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
